module.exports = __webpack_public_path__ + "logo-eLlaima.jpg?6066d0ed869da904f7643b6c8b64a30d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/logo-eLlaima.jpg
// module id = 76
// module chunks = 0